import { __ } from '@wordpress/i18n'

export default {
  labels: {
    submit: __('Absenden', 'dhsv_theme'),
    name: __('Name', 'dhsv_theme'),
    company: __('Firma', 'dhsv_theme'),
    kundennummer: __('Kundennummer', 'dhsv_theme'),
    email: __('E-Mail', 'dhsv_theme'),
    phone: __('Telefon', 'dhsv_theme'),
    days: __('Wunsch-Wochentage', 'dhsv_theme'),
    comment: __('Ihre Nachricht an uns', 'dhsv_theme'),
    gdpr: __(
      'Ja, ich habe die <a href="/datenschutz">Datenschutzerklärung</a> gelesen',
      'dhsv_theme'
    ),
    makeAppointment: __('Termin vereinbaren', 'dhsv_theme'),
  },
  success_message: __(
    'Vielen Dank für Ihr Interesse an EL Config+. Gerne erstellen wir Ihnen hierzu ein passendes Angebot anhand Ihrer Wünsche und Bedürfnisse. Füllen Sie dazu einfach das Formular aus, wir melden uns anschließend mit einem Terminvorschlag und den erwarteten Kosten.',
    'dhsv_theme'
  ),
  selectOptions: {
    days: {
      mon: __('Montag', 'dhsv_theme'),
      tue: __('Dienstag', 'dhsv_theme'),
      wed: __('Mittwoch', 'dhsv_theme'),
      thu: __('Donnerstag', 'dhsv_theme'),
      fri: __('Freitag', 'dhsv_theme'),
    },
  },
  validationMessages: {
    name: __('Bitte füllen Sie das Feld "Name" aus', 'dhsv_theme'),
    company: __('Bitte füllen Sie das Feld "Firma" aus', 'dhsv_theme'),
    kundennummer: __(
      'Bitte füllen Sie das Feld "Kundennummer" aus',
      'dhsv_theme'
    ),
    email: __('Bitte geben Sie eine gültige E-Mail-Adresse an', 'dhsv_theme'),
    phone: __('Bitte füllen Sie das Feld "Telefon" aus', 'dhsv_theme'),
    days: __('Bitte wählen Sie mindestens einen Wochentag aus', 'dhsv_theme'),
    gdpr: __('Bitte stimmen Sie der Übermittlung Ihrer Daten zu', 'dhsv_theme'),
  },
}
